import { render } from "./HospitalAccountManagers.vue?vue&type=template&id=98798588"
import script from "./HospitalAccountManagers.vue?vue&type=script&lang=js"
export * from "./HospitalAccountManagers.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/accountsManagers/HospitalAccountManagers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "98798588"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('98798588', __exports__)) {
    console.log('reload')
    api.reload('98798588', __exports__)
  }
  
  module.hot.accept("./HospitalAccountManagers.vue?vue&type=template&id=98798588", () => {
    console.log('re-render')
    api.rerender('98798588', render)
  })

}


export default __exports__